import styled, { css } from 'styled-components';

import { Visibility } from '../../../../Visibility';

import MobileCenterRulerImage from '@/assets/LineCenterMobile.svg';

export const Wrapper = styled.div<{
  $backgroundColor: string;
}>`
  height: 100%;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  text-decoration: none;
  text-align: center;
  ${({ $backgroundColor, theme }) => css`
    background-color: ${$backgroundColor};
    padding: ${theme.spacing(0, 1)};
  `}
`;
export const LabelBox = styled.div<{
  $backgroundColor: string;
  $isActive: boolean;
}>`
  position: relative;
  ${({ $backgroundColor, $isActive, theme }) => css`
      background-color: ${$backgroundColor};
    color: ${theme.colors.secondary};
    font-family: ${({ theme }) => theme.fontFamilies.italianPlate};
    font-size: ${theme.spacing(3.75)}; 

    &::after {
      content: '';
      position: absolute;
      bottom: -11px;
      left: 50%;
       display: block;
      transform: translate(-50%, -50%);
      width: 100%;
      height: 2.5px;
      background-color: ${theme.colors.black};
      opacity:0;
      font-weight: 600;
      }
    }
      &:hover  {
          opacity:1;
          text-shadow:
          -0.4px -0.4px 0 #000,
          0.4px -0.4px 0 #000,
          -0.4px 0.4px 0 #000,
          0.4px 0.4px 0 #000;
          transition:all 0.5s ease-in;
      }
      &:hover::after {
        opacity:1;
        font-weight: 600;
        transition:all 0.5s ease-in;
      }
      ${
        $isActive &&
        css`
         text-shadow:
          -0.4px -0.4px 0 #000,
          0.4px -0.4px 0 #000,
          -0.4px 0.4px 0 #000,
          0.4px 0.4px 0 #000; 
      &::after {
        font-weight: 600;
        opacity:1;
        
      }}
      
    `
      }
  `}
`;
export const Label = styled.span`
  text-transform: uppercase;
  text-align: center;
  display: inline-block;

  ${({ theme }) => css`
    margin: 0;
    color: ${theme.colors.secondary};
    ${({ theme }) => theme.media.md.up} {
      margin: ${theme.spacing(2, 0)};
    }
  `}
`;

export const DesktopWrapper = styled(Visibility)`
  max-width: 288px;
  height: 100%;
  text-align: center;
  cursor: pointer;
`;

export const MobileWrapper = styled(Visibility)`
  max-width: 130px;
  height: 100%;
  display: flex;
  flex-direction: column;
  &:last-child {
    max-width: 131px;
    min-width: 131px;
  }
`;
export const MobileLabel = styled.span<{
  $backgroundColor: string;
}>`
  text-transform: uppercase;
  text-align: center;
  display: inline-block;
  ${({ $backgroundColor, theme }) => css`
    background-color: ${$backgroundColor};
    margin: 0;
    color: ${theme.colors.secondary};
    padding: ${theme.spacing(0, 1)};
  `}
`;
export const MobileExhibitionWrapper = styled.div<{ $isActive: boolean }>`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-decoration: none;
  position: relative;
  text-align: center;
  background: url(${MobileCenterRulerImage});
  width: 100%;
  height: 24px;
  ${({ $isActive, theme }) => css`
    color: ${theme.colors.secondary};
    font-size: ${theme.fontSizes.h6}; 
    font-family: ${({ theme }) => theme.fontFamilies.italianPlate};
    font-weight: 500; 
      ${
        $isActive &&
        css`
          &::after {
            content: '';
            position: absolute;
            bottom: -15px;
            width: 50%;
            height: 2.5px;
            display: inline-block;
            background-color: ${theme.colors.black};
            opacity: 1;
            font-weight: bold;
            font-size: ${theme.fontSizes.h6};
          }
        `
      }
    }
  `}
`;
